<template>
    <div class="wrap-chat-item" @click="$emit('select')" v-if="(status == 'open' || 'in_progress') && bisa">
        <div class="detail">
            <h5>{{ namapt }}</h5>
            <p>{{ notiket }}</p>
            <p><small>{{ msg }}</small></p>
        </div>

        <div class="date">
            <p><small>{{ date }}</small></p>
            <p class="new" v-if="sender == 3">
                <small>chat baru</small>
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: "ChatItemModel",
    data() {
        return {};
    },
    emits: ["select"],
    props: {
        namapt: String,
        notiket: String,
        msg: String,
        date: String,
        sender : Number,
        status : String,
        isditandai : Boolean,
        type : String,
        visible : Boolean
    },
    components: {},
    mounted() { },
    computed: {
        bisa(){
            if(this.type == 'tanda' && this.isditandai == true){
                return true
            }else if (this.type == 'regular' && this.isditandai == true){
                return false
            }

            if(this.type == 'regular' && this.visible == false ){
                return false
            }

            if(this.type == 'regular' && this.isditandai == false && this.visible == false){
                return false
            }

            if(this.type == 'tanda' && this.visible == false){
                return false
            }

            return true 
        }
    },
    methods: {},
}
</script>
<style scoped>
.wrap-chat-item {
    background-color: none;
    margin: 10px;
    padding: 7px 10px;
    border-radius: 10px;
    display: flex;
    cursor: pointer;
}

.wrap-chat-item:hover{
    background-color: #e4e4e4;
}

.date{
    margin-left: 20px;
    background-color: none;
    display: flex;
    background-color: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .new{
        background-color: #e8f4ff;
        color: #098cff;
        padding: 5px 7px;
        border-radius: 10px;
    }
}

.detail {
    h5{
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 270px;
    }
    p:nth-child(2){
        color: #757575;
        font-size: 10pt;
    }
    p:nth-child(3) {
        font-size: 12pt;
        max-width: 250px;
        color: #adadad;

        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}
</style>